<template>
  <div class="report-person-input">
    <el-input v-model="label" readonly>
      <template v-if="!disabled" #append>
        <el-button icon="el-icon-more" @click="open()" />
      </template>
    </el-input>

    <Selector :visible.sync="visible" :data="data" @confirm="confirm" />
  </div>
</template>

<script>
import lodash from 'lodash'
import Selector from './selector'
export default {
  components: { Selector },
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { visible: false, data: [] }
  },
  computed: {
    label() {
      return lodash
        .map(this.value, (user) =>
          [user.userName, user.userNo ? `（${user.userNo}）` : '']
            .filter(Boolean)
            .join(''),
        )
        .filter(Boolean)
        .join('、')
    },
  },
  methods: {
    open() {
      this.visible = true
      this.data = lodash.cloneDeep(this.value)
    },
    confirm(data) {
      this.$emit('input', data)
      this.$emit('change', data)
    },
  },
}
</script>

<style lang="scss">
.el-form-item.is-error .report-person-input {
  .el-input-group__append {
    border-color: #f56c6c !important;
  }
}
</style>
